import React,{ useState, useEffect} from 'react';
import { Box, Button } from '@mui/material';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BASE_URL } from "../../App";
import { Row, Col } from 'antd';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import DynamicTable from '../Reusable/DynamicTable';
import axios from 'axios';
import CustomTextField from "../Reusable/Numerictext";
import Swal from 'sweetalert2';
import CustomButton from '../Reusable/CustomButton';
import { SelectNormal, SelectSearch, MultipleSelect } from '../Reusable/SelectBox';
import { Alert } from 'bootstrap';
import {Backdrop, CircularProgress, } from '@mui/material';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const Example = () => {
    const [validationErrors, setValidationErrors] = useState({});
    const [editedRowData, setEditedRowData] = useState(null);
    const [isCreateUserPopupOpen, setCreateUserPopupOpen] = useState(false);
    const [editingRow, setEditingRow] = useState(null);
    const [viewData, setViewedData] = useState(null);
    const [isViewPopupOpen, setViewPopupOpen] = useState(false);
    const [psglist, setPsglist] = useState([]);
    //const [itemlist, setItemlist] = useState([]);
    const [CATEGORY, setCATEGORY] = useState([]);
    const [isStartDayEntered, setIsStartDayEntered] = useState(false);
    const [loading, setloading] = React.useState(false);
    var LOGINID = localStorage.getItem('LOGIN_ID')
    const handleCreateUser = async ({ values, row, table }) => {
        console.log('New User Entered values:', values);
        setValidationErrors({});
        fetchData();
        //table.setCreatingRow(null);
    };
    const handleSaveUser = async ({ values, table }) => {
        setValidationErrors({});
        table.setEditingRow(null);
        fetchData();

    };
 
    const handleView = (row) => {
        setViewedData(row.original);
        setViewPopupOpen(true);
    };
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.post(BASE_URL+'/getrcpitemconfigurationpsg', {
                    login_id: LOGINID
                });

                const responseData = response.data;

               
                const psg_list = responseData.rcpitemconfigurationpsg || [];
                console.log("Branch List:", psg_list);
                setPsglist(psg_list);

               
                const Categorycode = responseData.dealercategorylist || [];
                console.log("CATEGORY:", Categorycode);
                setCATEGORY(Categorycode);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    const ViewDataPopup = ({ data, onClose }) => {
        return (
            <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth>
                <DialogTitle><u><b>View Configuration</b></u></DialogTitle>
                <DialogContent>
                    <Row>
                        <Col xs={22} sm={10}>
                            <TextField label="PSG" fullWidth value={data.PSG} margin="normal" InputProps={{ readOnly: true, }} />
                        </Col>
                        <Col xs={4} sm={2}></Col>
                        <Col xs={22} sm={10}>
                            <TextField label="Item Code" fullWidth value={data.Item_Code} margin="normal" InputProps={{ readOnly: true, }} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={22} sm={10}>
                            <TextField label="Item Description" fullWidth value={data.Item_Description} margin="normal" InputProps={{ readOnly: true, }} />
                        </Col>
                        <Col xs={4} sm={2}></Col>
                        <Col xs={22} sm={10}>
                            <TextField label="HP" fullWidth value={data.HP} margin="normal" InputProps={{ readOnly: true, }} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={22} sm={10}>
                            <TextField label="Head Range Maximum" fullWidth value={data.Head_Range_Maximum} margin="normal" InputProps={{ readOnly: true, }} />
                        </Col>
                        <Col xs={4} sm={2}></Col>
                        <Col xs={22} sm={10}>
                            <TextField label="Head Range Minimum" fullWidth value={data.Head_Range_Minimum} margin="normal" InputProps={{ readOnly: true, }} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={22} sm={10}>
                            <TextField label="Flow Maximum" fullWidth value={data.Flow_Maximum} margin="normal" InputProps={{ readOnly: true, }} />
                        </Col>
                        <Col xs={4} sm={2}></Col>
                        <Col xs={22} sm={10}>
                            <TextField label="Flow Minimum" fullWidth value={data.Flow_Minimum} margin="normal" InputProps={{ readOnly: true, }} />
                        </Col>
                    </Row>
                </DialogContent>
                <DialogActions style={{ justifyContent: 'center' }}>
                    <CustomButton
                        label="CLOSE"
                        onClick={onClose}
                        variant="outlined"
                        // color="error"
                        fullWidth
                        width="200px"
                    // height={40}
                    // borderRadius="8px"
                    />
                </DialogActions>

            </Dialog>
        );
    };

    const EditUserPopup = ({ user, onSave, onClose }) => {
        const [editedUser, setEditedUser] = useState({ ...user });
        const [itemlist, setItemlist] = useState([]);
        const [Item_Description, setItem_Description] = useState([]);
        const [Errormsg, setErrormsg] = useState('');
        const validateInput = () => {
            if (!editedUser.PSG || !editedUser.Item_Code || !editedUser.HP || !editedUser.Head_Range_Maximum || !editedUser.Head_Range_Minimum || !editedUser.Flow_Maximum||!editedUser.Flow_Minimum) {
               setErrormsg('Please fill in all fields!');
              
                return false;
            }
            return true;
            
        };
        const data = {

            psg: editedUser.PSG,
            itemcode: editedUser.Item_Code,
            itemdescription:Item_Description,
            hp: editedUser.HP,
            headrangemax: editedUser.Head_Range_Maximum,
            headrangemin: editedUser.Head_Range_Minimum,
            flowmax: editedUser.Flow_Maximum,
            flowmin: editedUser.Flow_Minimum,
            login_id: LOGINID,

        };
        const update = {
            psg: editedUser.PSG,
            itemcode: editedUser.Item_Code,
            itemdescription:editedUser.Item_Description,
            hp: editedUser.HP,
            headrangemax: editedUser.Head_Range_Maximum,
            headrangemin: editedUser.Head_Range_Minimum,
            flowmax: editedUser.Flow_Maximum,
            flowmin: editedUser.Flow_Minimum,
            login_id: LOGINID,

        };
       

      
        const handleSave = async () => {
            if (!validateInput()) {
                return ;
            }
            try {
                let response;
                if (user) {
                  
                    var a = parseInt(update.flowmax)
                    var b = parseInt(update.flowmin)
                    if(update.headrangemax < update.headrangemin){
                        
                        setErrormsg('The Head Range Minimum should be less than Head Range Maximum.');
                       
                       return;

                       
                    }

                    
                   
                    else if(a < b){
                        setErrormsg('The Flow Minimum should be less than Flow Maximum.');
                      
                       return;

                       
                    }
                    else{
                       
                        response = await axios.post(BASE_URL+'/rcphpheadconfigurationupdate', update);

                       
                    }

                   
                   

                    // useEffect();
                } else {
                    var a = parseInt(update.flowmax)
                    var b = parseInt(update.flowmin)
                    if(data.headrangemax < data.headrangemin){
                        setErrormsg('The Head Range Minimum should be less than Head Range Maximum.');
                       
                       return;

                       
                    }
                    else if(a < b){
                        setErrormsg('The Flow Minimum should be less than Flow Maximum.');
                       
                       return;

                       
                    }else {
                        response = await axios.post(BASE_URL+'/rcphpheadconfigurationcreate', data);
                       
                    }


                }
                if (response.data.status_code == '400') {
                  
                    setErrormsg('Data is not Saved, Please Try Again');
                     return false;;
                 }
                 else if(response.data.status_code == '200') {
 
                     Swal.fire({
                         icon: 'success',
                         text: response.data.text || 'Data saved successfully!',
                     });
                     setErrormsg('');
                 }

            }  catch (error) {

                console.error('Error inserting data:', error);
           

                if (error.response) {
                    const errorMessages = error.response.data.message;
                    const errorMessageList = errorMessages.map((message, index) => `${index + 1}. ${message}`).join('\n');
                
                    // Swal.fire({
                    //     allowOutsideClick: false,
                    //     position: 'top-end',
                    //     icon: 'error',
                    //     title: 'Error',
                    //     text: errorMessageList,
                    //     timer: 3000,
                    //     showConfirmButton: false,
                    //     timerProgressBar: true,
                    //     customClass: {
                    //         popup: 'custom-popup-class',
                    //     },
                      
                    // });
                    setErrormsg('Please Fill in All Fields');
                    
                    return;
                   
                }else if (error.code === '23505') { // 23505 is the SQL error code for duplicate key violation in SQL Server
                    // Swal.fire({
                    //     icon: 'error',
                    //     text: 'Cannot insert duplicate key. This record already exists.'
                    // });
                    setErrormsg('The Data Already exists');
                }
                 else if (error.request) {
                    // The request was made but no response was received
                    // Swal.fire({
                    //     icon: 'error',
                    //     title: 'Error',
                    //     text: 'No response received from the server.',
                    // });
                    setErrormsg('Data is not Saved, Please Try Again');
                } else {
                    // // Something happened in setting up the request that triggered an Error
                    // Swal.fire({
                    //     icon: 'error',
                    //     title: 'Error',
                    //     text: 'Error setting up the request. Please try again.',
                    // });
                    setErrormsg('Data is not Saved, Please Try Again');
                }
            }
            onSave(editedUser);
            onClose();
        };

        const PSG = psglist ? psglist.map((psgitem) => ({
            Value: psgitem.PSG,
            //Label: psgitem.PSG,
            Label: `${psgitem.PSG} - ${psgitem.DESCRIPTION}`,
        })) : [];



        const itemcodes = itemlist ? itemlist.map((item) => ({
            Value: item.itemcode,
            Label: `${item.itemcode} - ${item.item_description}`,
            Key:item.item_description,
        })) : [];

       

        {
            CATEGORY.map((branchItem) => (
                <MenuItem key={branchItem.CATEGORY} value={branchItem.CATEGORY}>
                    {branchItem.CATEGORY}
                </MenuItem>
            ))
        }


        const handlePSGChange = (newValue) => {
            setEditedUser({ ...editedUser, PSG: newValue });


            axios.post(BASE_URL+'/getrcpheadconfigurationitemcode', {
                login_id: LOGINID,
                PSG: newValue
            })
                .then(response => {
                    const responseData = response.data;
                    const item_list = responseData.getrcpheadconfigurationitemcode || [];
                    setItemlist(item_list);
                })
                .catch(error => {
                    // Handle any errors that occur during the API call
                    console.error('API Error:', error);
                });
        };


        const handleItemCodeChange = (newValue1) => {

            setEditedUser({ ...editedUser, Item_Code: newValue1 });
          setEditedUser({ ...editedUser, Item_Code: newValue1 });

            const selectedItem = itemcodes.find(item => item.Value === newValue1);
        
          
            if (selectedItem) {
                setItem_Description(selectedItem.Key);
            }

        };


        return (
            <Dialog open={true} onClose={onClose} maxWidth="sm" BackdropProps={{ invisible: true }}>
                <DialogTitle>
                    <u>
                        <b>{user ? 'Edit Configuration' : 'Create New Configuration'}</b>
                    </u>
                </DialogTitle>
                <DialogContent>
                    <Row>
                        <Col xs={44} sm={22}>

                            {!!user ? (
                                <SelectNormal
                                    readOnly={true}
                                    label="PSG"
                                    options={PSG}
                                    value={editedUser.PSG}
                                    onChange={(e) => setEditedUser({ ...editedUser, PSG: e.target.value })}
                                />
                            ) : (
                                <SelectSearch
                                    label="PSG"
                                    options={PSG}
                                    value={editedUser.PSG}
                                    //onChange={(newValue) => setEditedUser({ ...editedUser, PSG: newValue })}
                                    onChange={handlePSGChange}
                                />
                            )}

                        </Col>
                        {/* <Col xs={4} sm={2}></Col>
                        <Col xs={22} sm={10}>
                         

                        </Col> */}
                    </Row>
                    <Row>
                        <Col xs={44} sm={22}>

                        {!!user ? (
                               <TextField
                               label="Item"
                               select
                               fullWidth
                               value={editedUser.Item_Code}
                               onChange={(e) => setEditedUser({ ...editedUser, Item_Code: e.target.value })}
                               readOnly={true}
                           >
                               <MenuItem value={editedUser.Item_Code}>
                                   {`${editedUser.Item_Code} - ${editedUser.Item_Description}`}
                               </MenuItem>
                           </TextField>
                            ) : (
                               
                                <SelectSearch
                                    label="Item"
                                    options={itemcodes}
                                    value={editedUser.Item_Code}
                                    onChange={(newValue) => handleItemCodeChange(newValue)} // Ensure that newValue is passed to the handler
                                />

                            )}
                        </Col>
                       
                    </Row>
                   
                    <Row>
                        <Col xs={22} sm={10}>
                        <CustomTextField
                                label="H P"
                                name="HP"
                                maxLength="5"
                                type="number"
                                value={editedUser.HP}
                                onChange={(e) => {
                                    let inputValue = e.target.value.trim();
                                    inputValue = inputValue.replace(/[^0-9.]/g, ''); // Remove any non-numeric characters except '.'

                                    // Ensure that the input is not negative and not greater than 100
                                    if (inputValue === '' || (parseFloat(inputValue) >= 0 && parseFloat(inputValue) <= 100)) {
                                        setEditedUser({ ...editedUser, HP: inputValue });
                                    }
                                }}
                            />
                           
                        </Col>
                        <Col xs={4} sm={2}></Col>
                        <Col xs={22} sm={10}>
                           

                        <CustomTextField
                                label="Head Range Maximum"
                                name="Head_Range_Maximum"
                                maxLength="5"
                                type="number"
                                value={editedUser.Head_Range_Maximum}
                                onChange={(e) => {
                                    let inputValue = e.target.value.trim();
                                    inputValue = inputValue.replace(/[^0-9.]/g, ''); // Remove any non-numeric characters except '.'

                                    // Ensure that the input is not negative and not greater than 100
                                    if (inputValue === '' || (parseFloat(inputValue) >= 0 && parseFloat(inputValue) <= 100)) {
                                        setEditedUser({ ...editedUser, Head_Range_Maximum: inputValue });
                                    }
                                }}

                            />



                        </Col>
                    </Row>
                    <Row>
                        <Col xs={22} sm={10}>
                           

                        <CustomTextField
                                label="Head Range Minimum"
                                name="Head_Range_Minimum"
                                maxLength="5"
                                type="number"
                                value={editedUser.Head_Range_Minimum}
                                onChange={(e) => {
                                    let inputValue = e.target.value.trim();
                                    inputValue = inputValue.replace(/[^0-9.]/g, ''); // Remove any non-numeric characters except '.'

                                    // Ensure that the input is not negative and not greater than 100
                                    if (inputValue === '' || (parseFloat(inputValue) >= 0 && parseFloat(inputValue) <= 100)) {
                                        setEditedUser({ ...editedUser, Head_Range_Minimum: inputValue });
                                    }
                                }}
                            />
                        </Col>
                        <Col xs={4} sm={2}></Col>
                        <Col xs={22} sm={10}>
                        <CustomTextField
                                label="Flow Maximum"
                                name="Flow_Maximum"
                                maxLength="5"
                                type="number"
                                value={editedUser.Flow_Maximum}
                                onChange={(e) => {
                                    let inputValue = e.target.value.trim();
                                    inputValue = inputValue.replace(/[^0-9.]/g, ''); // Remove any non-numeric characters except '.'

                                    // Ensure that the input is not negative and not greater than 100
                                    if (inputValue === '' || (parseFloat(inputValue) >= 0 && parseFloat(inputValue) <= 100)) {
                                        setEditedUser({ ...editedUser, Flow_Maximum: inputValue });
                                    }
                                }}
                            />

                        </Col>
                    </Row>


                    <Row>
                        <Col xs={22} sm={10}>
                           

                        <CustomTextField
                                label="Flow Minimum"
                                name="Flow_Minimum"
                                maxLength="5"
                                type="number"
                                value={editedUser.Flow_Minimum}
                                onChange={(e) => {
                                    let inputValue = e.target.value.trim();
                                    inputValue = inputValue.replace(/[^0-9.]/g, ''); // Remove any non-numeric characters except '.'

                                    // Ensure that the input is not negative and not greater than 100
                                    if (inputValue === '' || (parseFloat(inputValue) >= 0 && parseFloat(inputValue) <= 100)) {
                                        setEditedUser({ ...editedUser, Flow_Minimum: inputValue });
                                    }
                                }}
                            />


                        </Col>
                        <Col xs={4} sm={2}></Col>
                        <Col xs={22} sm={10}>
                           

                        </Col>
                    </Row>

                    {Errormsg &&(
               
               <p style={{ color: "red" }}><b><h6>*{Errormsg}</h6></b></p>
           )}
                    <center>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <Stack direction="row" spacing={2} sx={{ width: '100%', maxWidth: '400px' }}>
                                    <CustomButton
                                        label={user ? 'Save' : 'Create'}
                                        onClick={handleSave}
                                        variant="outlined"
                                        size="medium"
                                        height={40}
                                        width="200px"
                                        borderRadius="8px"
                                        type="submit"
                                        sx={{ flexGrow: 1 }}

                                    />

                                    <CustomButton
                                        label="Cancel"
                                        onClick={onClose}
                                        variant="outlined"
                                        size="medium"
                                        height={40}
                                        width="200px"
                                        borderRadius="8px"
                                        type="submit"
                                        sx={{ flexGrow: 1 }}
                                        color="error"
                                    />
                                </Stack>
                                <br />
                            </div>
                        </Typography>
                    </center>
                </DialogContent>
            </Dialog>

        );
    };
    const [tableData, setTableData] = useState([]);

    const fetchData = () => {
        setloading(true);

        axios.post(BASE_URL+'/getrcphpheadconfiguration', { login_id: LOGINID })

            .then(response => {
                if (response.status === 200) {
                    setTableData(response.data.getrcphpheadconfigurations);
                    setloading(false);
                } else {
                    setloading(false);
                    console.error('Unexpected status code:', response.status);
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                // Handle errors here
                console.error('Error:', error);

                // Check if the error has a response
                if (error.response) {
                    // The request was made, but the server responded with a status code
                    // that falls out of the range of 2xx
                    console.error('Error response status:', error.response.status);
                    console.error('Error response data:', error.response.data);

                    // Display an alert with the error message
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    // The request was made, but no response was received
                    console.error('No response received');
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.error('Error setting up the request:', error.message);
                }
            });

        // }, []);
    }

    useEffect(() => {
        fetchData();
    }, []);

    const openCreateUserPopup = (rowData) => {

        // alert(`Edited Row Data: ${JSON.stringify(rowData)}`);
        setCreateUserPopupOpen(true);
        setEditedRowData(rowData);
    };
    const handleViewEditClick = (rowData) => {

        setViewedData(rowData);
        setViewPopupOpen(true);
    };
    return (
        <>
            <DynamicTable data={tableData} onEditClick={openCreateUserPopup} onViewClick={handleViewEditClick} />;

            {editingRow && (

                <EditUserPopup
                    user={editingRow.original}
                    onSave={(editedData) => {
                        handleSaveUser({ values: editedData, tableData });
                    }}
                    onClose={() => setEditingRow(null)}
                />
            )}
            {isCreateUserPopupOpen && (

                <EditUserPopup
                    user={editedRowData}
                    onSave={handleCreateUser}
                    onClose={() => {
                        setCreateUserPopupOpen(false);
                        setEditedRowData(null); // Clear the edited row data when closing the popup
                    }}
                />
            )}
            {isViewPopupOpen && (
                <ViewDataPopup
                    data={viewData}
                    onClose={() => setViewPopupOpen(false)}
                />
            )}
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
            <CircularProgress color="inherit" />
          </Backdrop>
        </>
    );
};

const queryClient = new QueryClient();

const ExampleWithProviders = () => (
    <QueryClientProvider client={queryClient}>
        <Example />
    </QueryClientProvider>
);

export default ExampleWithProviders;